module.exports = __webpack_public_path__ + "img/template-email-classic.943a6218.svg";